import PropTypes from "prop-types";

const ImageType = PropTypes.shape({
  src: PropTypes.string.isRequired,
  caption: PropTypes.string,
  source: PropTypes.string,
});

export default ImageType;
